import React from 'react';
import { ConfigClientType } from '../types/ConfigClientType';
import { getTranslation } from '../../constants/languages';
import { getPageExceptionTranslation } from '../../constants/siteIds';

type CallScheduleProps = {
    iimclient: ConfigClientType;
};

// Need to rewrite these preformatted strings to react components
const Translations = {
  lang_no: '<div><a href="https://www.if.no/privat/kundeservice/kontakt-oss#apningstider">Åpningstider privatkunder</a></div><p><a href="https://www.if.no/bedrift/kundeservice">Åpningstider bedriftskunder</a></p>',
  lang_se: '<div><a href="https://www.if.se/privat/kundservice#oppet">Öppettider privat</a></div><p><a href="https://www.if.se/foretag/kundservice">Öppettider företag</a></p>',
  lang_fi: null,
  lang_dk: '<a href="https://www.if.dk/privat/kontakt#tider">Åbningstider</a>',
  lang_en: null,
}

// Fill known exceptions here
const PageExceptions = {
  ksb: '',
  ksbMyBusiness: '',
}

const CallSchedule = ({ iimclient }: CallScheduleProps) => {
    const { texts, segment, schedule } = iimclient;

    const getSegmentScheduleText = () => {
        if (!segment) return undefined;
        if (schedule) {
            const scheduleText: string[] = [];
            schedule.forEach((sched) => {
                const getTime = () => {
                    if (!sched.opening && !sched.closing) return texts['closed'];
                    const ifhelp2015api = (window as any).ifhelp2015api;
                    const openingTime = ifhelp2015api.convertUTCTimeToLocal(sched.opening);
                    const closingTime = ifhelp2015api.convertUTCTimeToLocal(sched.closing);
                    if (openingTime == closingTime) return '24/7';
                    return openingTime + ' - ' + closingTime;
                };
                const weekdays = sched.weekdays;
                const firstVal = weekdays[0];
                const lastVal = weekdays[weekdays.length - 1];
                scheduleText.push(
                    (firstVal == lastVal
                        ? texts['days'][firstVal]
                        : texts['days'][firstVal] + ' - ' + texts['days'][lastVal]) +
                        ' : ' +
                        getTime()
                );
            });
            return scheduleText.join('<br />');
        }

        if (segment.opening_schedule) {
            return segment.opening_schedule;
        }

        return null;
    };

    const nonSegmentScheduleText = !segment && texts['call-schedule-text'];
    const scheduleText = getSegmentScheduleText() || nonSegmentScheduleText;

    return scheduleText && (
      <p
        id="scheduleText"
        className="after-phone"
        dangerouslySetInnerHTML={{ __html: scheduleText }}
      />
    );
};

export default CallSchedule;
